<template>
    <div class="card-slide swiper-slide">
        <div
            class="card-slide__header"
            :style="`background-image: url(${image})`"
            v-if="image !== ''"
        ></div>
        <div class="card-slide__content">
            <slot />
        </div>
    </div>
</template>

<script>
export default {
    name: 'card-slide',
    props: {
        image: {
            type: String,
            default: ''
        }
    }
}
</script>

<style lang="scss">
.card-slide {
    background: $token-colors-white;

    &__header {
        width: 100%;
        padding-top: 57%;
        background-size: cover;
        background-repeat: no-repeat;
        background-position: 50% 50%;
        background-color: #F8F8F8;
        position: relative;

        &:after {
            content: '';
            display: block;
            position: absolute;
            width: 100%;
            height: 100%;
            top: 0;
            left: 0;
            background: linear-gradient(0deg, rgba(0, 0, 0, 0.5) 0%, rgba(0, 0, 0, 0.05) 44.25%);
        }
    }

    &__content {
        padding: $token-spacers-l;
    }
}
</style>
